import { html, when } from '@microsoft/fast-element';
import type { MoreInfoIcon } from './more-info-icon';


export enum MoreInfoIconSize {
    SMALL = 'sm',
    LARGE = 'lg',
}

export const MoreInfoIconTemplate = html<MoreInfoIcon>`
  ${when(
    (x) => x.isVisible,
    html`
      <div class="more-info">
        <zero-icon
          variant="solid"
          size=${(x) =>  x.size ?? MoreInfoIconSize.LARGE}
          name="circle-question"
          @click=${(x) => x.openMoreInfo()}
        ></zero-icon>
      </div>
    `,
  )}
`;
